export default {
  data() {
    return {
      scrollHide: false,
      cacheFixedLR: 0,
    };
  },
  mounted() {
    const {
      position,
      left,
      right, _magic_position: magicPosition,
      fixed_max_width: fixedMaxWidth,
    } = this.config.style || {};

    if (!this.inMagic
      && position === 'fixed'
      && magicPosition?.startsWith('fixed')) {
      if (['fixedLeft', 'fixedRight'].indexOf(magicPosition) > -1) {
        if (magicPosition === 'fixedLeft') {
          this.config.style.right = '';
        } else {
          this.config.style.left = '';
        }
        // 但有配置最大宽度的吸左、右时，则计算可吸的最大边界（通常PC有需求：浮动时不超过1920的宽度）
        if (fixedMaxWidth) {
          this.cacheFixedLR = parseInt(magicPosition === 'fixedLeft' ? left : right, 10) || 0;
          this.resizeFunc();
          window.addEventListener('resize', this.resizeFunc, false);
        }
      }

      // eslint-disable-next-line no-underscore-dangle
      if (this.config.style._magic_visible === 'scroll') {
        // 有配置先设置滚动显示为 false，隐藏组件
        this.scrollHide = true;
        window.addEventListener('scroll', this.scrollFunc, false);
      }
    }
    this.handlePositionCenter();
  },
  updated() {
    this.handlePositionCenter();
  },
  methods: {
    resizeFunc() {
      const { fixed_max_width: fixedMaxWidth, _magic_position: magicPosition } = this.config.style || {};
      const result = (window.innerWidth - fixedMaxWidth) / 2;
      if (magicPosition === 'fixedLeft') {
        this.config.style.left = result > 0 ? this.cacheFixedLR + result : this.cacheFixedLR;
      } else if (magicPosition === 'fixedRight') {
        this.config.style.right = result > 0 ? this.cacheFixedLR + result : this.cacheFixedLR;
      }
    },
    scrollFunc() {
      // 默认超过 30 显示
      let top = 30;
      // 有配置则使用配置高度
      // eslint-disable-next-line no-underscore-dangle
      const vTop = parseInt(this.config.style?._magic_visible_top, 10);
      if (vTop > 0) {
        top = vTop;
      }
      const doc = document.scrollingElement;
      if (doc.scrollTop > top) {
        this.scrollHide = false;
      } else {
        this.scrollHide = true;
      }
    },

    handlePositionCenter() {
      const {
        position,
        _horizontal_center: isHorizontalCenter,
        _vertical_center: isVerticalCenter,
      } = this.config.style || {};

      const isAbsolute = position === 'absolute';

      if (isAbsolute && isHorizontalCenter) {
        this.$el.classList?.add('_horizontal-center');
      } else {
        this.$el.classList?.remove('_horizontal-center');
      }

      if (isAbsolute && isVerticalCenter) {
        this.$el.classList?.add('_vertical-center');
      } else {
        this.$el.classList?.remove('_vertical-center');
      }
    },
  },

  destroyed() {
    window.removeEventListener('resize', this.resizeFunc);
    window.removeEventListener('scroll', this.scrollFunc);
  },
};
